import { Paper, Popper } from '@mui/material';
import React, { useEffect, useRef } from 'react';

export default function CustomDefaultPaper(
  props: any,
  isDarkMode: any,
  handleScroll: any,
  scrollPosition: number,
  disableScroll: any,
) {
  const backGroundColor = isDarkMode ? '#2e2e2e' : '#ffffff';
  const textColor = isDarkMode ? '#ffffff' : '#000000';

  const paperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Update the scroll position when scrollPosition prop changes
    if (paperRef.current) {
      paperRef.current.scrollTop = scrollPosition;
    }
  }, [scrollPosition]);

  return (
    <Paper
      onScroll={handleScroll}
      ref={paperRef}
      style={{
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        border: '1px solid transparent',
        borderTop: 0,
        background: `linear-gradient(${backGroundColor}, ${backGroundColor}) padding-box, linear-gradient(90deg, #4248E0 0%, #4248E0 51.04%, #22C9C0 90%) border-box`,
        color: textColor,
        overflowY: disableScroll ? 'hidden' : 'auto',
      }}
        // eslint-disable-next-line
      {...props}
    />
  );
}

export function PopperBottom(props: any) {
  const modifiers = [
    {
      name: 'flip',
      options: {
        fallbackPlacements: [],
      },
    },
  ];

  return (
    <Popper
            {...props} // eslint-disable-line
      modifiers={modifiers}
      popperOptions={{
        placement: 'bottom',
      }}
    />
  );
}

export function PopperTop(props: any) {
  const modifiers = [
    {
      name: 'flip',
      options: {
        fallbackPlacements: [],
      },
    },
  ];

  return (
    <Popper
            {...props} // eslint-disable-line
      modifiers={modifiers}
      popperOptions={{
        placement: 'top',
      }}
    />
  );
}
